import React, { useState } from "react"
import { useTranslation } from "react-i18next"
import clsx from "clsx"

import { Button } from "components"
import { haveAuth, ObjectValues } from "utils"
import classes from "./PoGroupInvoicePrintButton.module.scss"

const PoGroupInvoicePrintButton = props => {
  const { selectedOrders } = props

  const [t, i18n] = useTranslation()

  const [sending, setSending] = useState(false)

  const handlePrintOrders = async () => {
    setSending(true)

    sessionStorage.setItem(
      "data",
      JSON.stringify({
        type: "orderInvoice",
        value: orders
      })
    )

    window.open("/print", "_blank")

    setSending(false)
  }

  const orders =
    ObjectValues(selectedOrders)

  const showPrintButton =
    orders.length > 0 &&
    haveAuth(["printerAccess"])

  const isLtr = i18n.dir(i18n.language) === "ltr"

  if (!showPrintButton) return null

  return (
    <Button
      loading={sending}
      color="secondary"
      onClick={handlePrintOrders}
      className={clsx(
        classes["button"],
        isLtr && classes["button-ltr"]
      )}
    >
      {t("پرینت_فاکتور_سفارشات")}
    </Button>
  )
}

export default PoGroupInvoicePrintButton